module.exports = __webpack_public_path__ + "static/media/geesaa_2.a1a56856.PNG";